import { getTenantId } from '../../utils/accountHelper';
import { getTabId } from '../../utils/tabId';

export const isTicketNews = (channel: string) => {
    return channel.startsWith(`urn:t/${getTenantId()}/r/TICKET-`);
};
export const isUserNews = (channel: string) => {
    return channel.startsWith(`urn:t/${getTenantId()}/u/`);
};
export const isTenantNews = (channel: string) => {
    return channel.startsWith(`urn:t/${getTenantId()}`);
};
export const isSessionNews = (channel: string) => {
    const tabId = getTabId();
    return channel.startsWith(`urn:s/${tabId}`);
};
export const isChatMessage = (channel: string) => {
    return channel === 'CHAT_MESSAGE';
};

export const getTicketKeyFromChannel = (channel: string) => {
    if (isTicketNews(channel)) {
        return channel.substring(channel.lastIndexOf('/') + 1);
    }
    return null;
};
